import api from './api';

export interface XaccelProxy {
  id: number;
  xaccelServerId: number;
  xaccelProxyId: number;
  name: string;
  type: string;
  host: string;
  port: number;
  username: string | null;
  password: string | null;
  isOnline: boolean;
  country: string | null;
  countryCode: string | null;
  lastCheck: number | null;
  serverName: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateProxyData {
  xaccelServerId: number;
  name: string;
  type?: string;
  host: string;
  port: number;
  username?: string;
  password?: string;
}

export interface SyncResult {
  success: boolean;
  synced: number;
  created: number;
  updated: number;
}

export interface AssignResult {
  success: boolean;
  assignedStreams?: number;
  channelNames?: string[];
  channelName?: string;
}

class XaccelProxyService {
  /**
   * List all proxies from local DB
   */
  async listProxies(): Promise<XaccelProxy[]> {
    const response = await api.get('/xaccel/proxies');
    return response.data;
  }

  /**
   * Sync proxies from all Xaccel servers
   */
  async syncProxies(): Promise<SyncResult> {
    const response = await api.post('/xaccel/proxies/sync');
    return response.data;
  }

  /**
   * Create a new proxy on Xaccel
   */
  async createProxy(data: CreateProxyData): Promise<{ success: boolean; id?: number; xaccelProxyId?: number; error?: string }> {
    const response = await api.post('/xaccel/proxies', data);
    return response.data;
  }

  /**
   * Update proxy
   */
  async updateProxy(id: number, data: Partial<CreateProxyData>): Promise<{ success: boolean; error?: string }> {
    const response = await api.put(`/xaccel/proxies/${id}`, data);
    return response.data;
  }

  /**
   * Delete proxy
   */
  async deleteProxy(id: number): Promise<{ success: boolean; error?: string }> {
    const response = await api.delete(`/xaccel/proxies/${id}`);
    return response.data;
  }

  /**
   * Assign proxy to competition channels by resolution
   */
  async assignToCompetition(competitionId: number, serverId: number, resolution: string, proxyId: number | null): Promise<AssignResult> {
    const response = await api.post('/xaccel/proxies/assign-competition', {
      competitionId,
      serverId,
      resolution,
      proxyId,
    });
    return response.data;
  }

  /**
   * Assign proxy to linear channel by resolution
   */
  async assignToLinear(linearChannelId: number, serverId: number, resolution: string, proxyId: number | null): Promise<AssignResult> {
    const response = await api.post('/xaccel/proxies/assign-linear', {
      linearChannelId,
      serverId,
      resolution,
      proxyId,
    });
    return response.data;
  }
}

export const xaccelProxyService = new XaccelProxyService();
export default xaccelProxyService;
